// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__VGGz9","question":"Question_question__1JU6H","description":"Question_description__1YG9w"};